import type { SVGProps } from 'react'
const SolidCheckCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M12 2C6.485 2 2 6.485 2 12s4.485 10 10 10 10-4.485 10-10S17.515 2 12 2m-.615 13.175a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L7.22 12.78l1.06-1.06 2.22 2.22 5.72-5.72 1.06 1.06z"
		/>
	</svg>
)
export { SolidCheckCircle }
